import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import { withRouter } from 'react-router-dom';
// import { getOrgByID } from './graphql';
// import { apiUrl } from '../../config/properties';
import { cloudFrontCdnUrl } from '../../config/properties';


export default function UploadInventoryHOC(UploadInventoryPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      onReturnToMainPage: PropTypes.func.isRequired,
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        jwtToken: PropTypes.string,
        email: PropTypes.string,
        cageCode: PropTypes.string,
      }).isRequired,
    };

    static initialState = {
      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
    };

    state = WrappedComponent.initialState;

    // _onFileSelect seems to no be used anywhere
    // _onFileSelect = async (e, auth) => {
    //   this.setState({
    //     alertMessage: '',
    //     alertType: '',
    //   });
    //   try {
    //     const res = await S3FileUpload(e, auth, 'partnumbers');
    //     console.log(res);
    //     this.setState({
    //       alertType: 'success',
    //       alertMessage:
    //         'Upload successful! Your file has been successfully uploaded although it may take up to 30 minutes to see your results.',
    //     });
    //   } catch (error) {
    //     this.setState({
    //       alertType: 'warning',
    //       alertMessage:
    //         'File failed to upload. It seems something went wrong uploading your file.\n Please try again in a few minutes. If the problem persists, please contact support',
    //     });
    //   }
    // };

    _hideMessage = () => this.setState({ alertMessage: '', alertType: '' });

    _handleUpload = async option => {
      const { onSuccess, file } = option;

      // Read CSV file content
      const csvContent = await this._readFileAsText(file);

      const config = {
        url: `${cloudFrontCdnUrl}/api-v1/inventory/bulk-upload`,
        method: 'post',
        headers: {
          Authorization: `${this.props.auth.cageCode}|${this.props.auth.jwtToken}`,
          'Content-Type': 'text/plain',
        },
        data: csvContent,
        onUploadProgress: ({ total, loaded }) => {
          this.setState({
            alertType: 'info',
            alertMessage: `Uploading ${Math.round(
              (loaded / total) * 100,
            )}%`,
          });
        },
      };

      try {
        const res = await Axios(config);
        onSuccess(res.data);

        const { successCount, failureCount, totalProcessed, errors } = res.data;

        if (res.data.status === 'SUCCESS') {
          this.setState({
            alertType: 'success',
            alertMessage: `Upload successful! Processed ${totalProcessed} items. All ${successCount} items were uploaded successfully.`,
          });
        } else if (res.data.status === 'PARTIAL_SUCCESS') {
          this.setState({
            alertType: 'warning',
            alertMessage: `Upload partially successful! Processed ${totalProcessed} items. ${successCount} succeeded, ${failureCount} failed. Check console for details.`,
          });
          console.warn('Upload errors:', errors);
        } else {
          this.setState({
            alertType: 'danger',
            alertMessage: `Upload failed! ${res.data.msg || 'Please check your CSV format and try again.'}`,
          });
        }
      } catch (error) {
        console.error('Upload error:', error);
        this.setState({
          alertType: 'danger',
          alertMessage:
            'File failed to upload. Please check your CSV format and try again. If the problem persists, please contact support.',
        });
      }
    };

    _readFileAsText = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (e) => reject(e);
      reader.readAsText(file);
    });


    render() {
      const { onReturnToMainPage } = this.props;
      const {
        alertType,
        alertMessage,
      } = this.state;

      // Configure Page
      const pageProps = {
        handleUpload: this._handleUpload,
        alertType,
        alertMessage,
        hideMessage: this._hideMessage,
        onReturnToMainPage
      };

      return <UploadInventoryPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/UploadInventory/UploadInventoryHOC.jsx